import { useContext, useEffect, useState } from "react";
import { config, activeDateFilter as ADF } from "../../../../constant";
import { useElement, useLocale, useService } from "../../../../hooks";
import { AppContext } from "../../../../context";

export const useCompanyManagers = () => {
  const { t } = useLocale();
  const Img = useElement("Img");
  const { commonPageSize } = config;
  const {
    getLoggedInUserData,
    getCompanyBranches,
    getActiveBranches,
    getBranchManagers,
    setGlobalActiveBranches,
  } = useService("User");
  const { setTitle } = useService("Meta");
  const { actions: { showPreloader, hidePreloader } } = useContext(AppContext);
  const { isBottom, showAlert } = useService("Misc");
  const user = getLoggedInUserData();
  const [tableContent, settableContent] = useState(null);
  const [activeDateFilter, setactiveDateFilter] = useState(ADF[0]);
  const [activeBranches, setactiveBranches] = useState([]);
  const [branches, setbranches] = useState([]);
  const [tableData, settableData] = useState([]);
  const [filteredList, setfilteredList] = useState([]);
  const [checkedList, setcheckedList] = useState([]);
  const [activeShownTotal, setactiveShownTotal] =
    useState<number>(commonPageSize);
  const [checkedAll, setcheckedAll] = useState<boolean>(false);

  setTitle(t("companyManagers"));
  useEffect(() => {
    let orgId = false;
    if (user?.role === "representative") {
      orgId = user.parent?.value;
      getCompanyBranchesList(orgId);
    } else if (user?.role === "company") {
      orgId = user.uid;
      getCompanyBranchesList(orgId);
    } else {
      getBranchManagersData();
    }
  }, []);

  const trackScrolling = () => {
    const wrappedElement = document.getElementById("list-wrapper");
    if (isBottom(wrappedElement)) {
      if (
        filteredList.length > commonPageSize &&
        activeShownTotal < filteredList.length
      )
        showMore();
    }
  };

  const showMore = () => {
    showPreloader();
    setTimeout(() => {
      hidePreloader();
      setactiveShownTotal(activeShownTotal + commonPageSize);
    }, 300);
  };

  const getDashboardData = (activeDateFilter, activeBranches) => {
    let activeBranchIds = [];
    activeBranches?.forEach((e) => {
      activeBranchIds.push(e.value);
    });
    getBranchManagersData(activeBranchIds);
  };

  const getCompanyBranchesList = async (v) => {
    let query = {
        parentId: v,
      },
      branches = [];
    const result = await getCompanyBranches(query);
    if (result.status) {
      result.data.forEach((e) => {
        branches.push({
          label: e.name,
          value: e.uid,
        });
      });
      let activeBranches =
        getActiveBranches() === null ? getActiveBranches() : branches;
      setbranches(branches);
      setactiveBranches(activeBranches);
      setGlobalActiveBranches(activeBranches);
      getDashboardData(activeDateFilter, activeBranches);
    }
  };

  const getBranchManagersData = async (branches?: string[]) => {
    let query = {
      parentId: user.uid,
    };
    if (branches) {
      query.parentId = {
        $in: branches,
      };
    }
    const result = await getBranchManagers(query);
    if (result.status) {
      let tableData = [];
      result.data.forEach((e) => {
        tableData.push(e);
      });
      if (result.data?.length === 0) {
        showAlert({ type: "error", msg: t("errorMsg.fail.managerNotFound") });
      } else {
        settableData(tableData);
        setfilteredList(tableData);
      }
    }
  };

  const getTableData = (filterData) => {
    let data = [];
    filterData.map((item) => {
      let e = {
        name: item.name,
        email: item.email,
        mobile: item.mobile,
        image: item.image ? (
          <Img
            src={JSON.parse(item.image)[0]}
            style={{ maxHeight: 40, maxWidth: 40 }}
          />
        ) : (
          <p>{t("noImage")}</p>
        ),
      };
      data.push(e);
    });
    return data;
  };

  const selectCompany = (e) => {
    setactiveBranches(e);
    setGlobalActiveBranches(e);
    getDashboardData(activeDateFilter, e);
  };

  useEffect(() => {
    settableContent({
      headers: [
        {
          label: t("name"),
          key: "name",
        },
        {
          label: t("email"),
          key: "email",
        },
        {
          label: t("mobile"),
          key: "mobile",
        },
        {
          label: t("image"),
          key: "image",
        },
      ],
      content: getTableData(filteredList),
    });
  }, [filteredList, checkedAll, checkedList]);
  return {
    user,
    branches,
    activeBranches,
    selectCompany,
    tableContent,
    activeShownTotal,
  };
};
